export type ChecklistPayloadGroup = {
  title: string
  items: string[]
}

export type ChecklistPayload = {
  groups: ChecklistPayloadGroup[]
  proofGates?: string[]
  ownerRoles?: string[]
}

const asRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === 'object' ? value as Record<string, unknown> : {}

const asStringList = (value: unknown): string[] =>
  Array.isArray(value) ? value.map(String).map((item) => item.trim()).filter(Boolean) : []

const asItemList = (value: unknown): string[] =>
  Array.isArray(value) ? value.map(String) : []

export const normalizeChecklistPayload = (value: unknown): ChecklistPayload => {
  const payload = asRecord(value)
  const groups = Array.isArray(payload.groups)
    ? payload.groups.map((group, index) => {
      const record = asRecord(group)
      return {
        title: typeof record.title === 'string' ? record.title : `Group ${index + 1}`,
        items: asItemList(record.items),
      }
    })
    : []
  const next: ChecklistPayload = { groups }
  const proofGates = asStringList(payload.proofGates)
  const ownerRoles = asStringList(payload.ownerRoles)
  return {
    ...next,
    ...(proofGates.length > 0 ? { proofGates } : {}),
    ...(ownerRoles.length > 0 ? { ownerRoles } : {}),
  }
}
